/* eslint-disable */
export default class FullScreenAPI {
  static enter(element) {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else if (element.webkitEnterFullscreen) {
      // For iOS devices
      element.webkitEnterFullscreen();
    }
  }

  static exit() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.webkitExitFullscreen) {
      // For iOS devices
      document.webkitExitFullscreen();
    }
  }

  static isEnabled() {
    const fullscreenEnabled =
      document.fullscreenEnabled ||
      document.mozFullScreenEnabled ||
      document.webkitFullscreenEnabled ||
      document.msFullscreenEnabled ||
      false;

    return fullscreenEnabled;
  }

  static isIPhone() {
    return /iPhone/i.test(navigator.userAgent);
  }

  static isFullScreen() {
    // eslint-disable-next-line no-restricted-globals
    return window.innerHeight === screen.height && window.innerWidth === screen.width;
  }
}
